// Converte i ratio di posizione/dimensione del soggetto (0..1, relativi al
// canvas) in percentuali per lo stile inline del <div> alone sovrapposto
// all'anteprima. Nessun clamp: la fedeltà è voluta, il container taglia
// l'eccesso con overflow:hidden.
export const computeHaloRect = ({
  centerXRatio,
  centerYRatio,
  widthRatio,
  heightRatio,
}) => ({
  leftPct: (centerXRatio - widthRatio / 2) * 100,
  topPct: (centerYRatio - heightRatio / 2) * 100,
  widthPct: widthRatio * 100,
  heightPct: heightRatio * 100,
});
